import styled from 'styled-components';

export const Hr = styled.hr`
  width: 100%;
  height: 1px;
  border: 0;
  background: #d7d7d7;
`;
